import interceptor from '../common/interceptor';
import { APIPaths } from '../common/constants';
import { ApiResponse } from '@/apis/types';

export interface FreightMarkupRateData {
  id: string;
  team_id: string;
  team_name: string;
  courier_id: string;
  courier_name: string;
  service_level: string;
  service_level_display?: string;
  markup_percent: string | number;
  created_at: string;
  updated_at: string;
}

export interface FreightMarkupRateWritePayload {
  team_id: string;
  courier_id: string;
  service_level: string;
  markup_percent: number;
}

export interface FreightMarkupRateServiceLevelOption {
  original_service_level: string;
  display_name: string;
}

export interface FreightMarkupRateCarrierOption {
  id: string;
  name: string;
  /** Stable FedEx | UPS bucket for Clients-style columns. */
  bucket?: 'FedEx' | 'UPS' | string;
  service_levels: FreightMarkupRateServiceLevelOption[];
}

export interface FreightMarkupRateTeamOption {
  id: string;
  name: string;
  color?: string | null;
}

export interface FreightMarkupRateOptionsData {
  teams: FreightMarkupRateTeamOption[];
  carriers: FreightMarkupRateCarrierOption[];
}

export const GetFreightMarkupRates = (
  token: string,
  search = ''
): Promise<ApiResponse<FreightMarkupRateData[]>> => {
  const q = search.trim() ? `?search=${encodeURIComponent(search.trim())}` : '';
  return new Promise((resolve, reject) => {
    interceptor
      .axiosGet('Get', `${APIPaths.freightMarkupRates}${q}`, token, null)
      .then((res) =>
        resolve(res as unknown as ApiResponse<FreightMarkupRateData[]>)
      )
      .catch((error) => reject(error?.response));
  });
};

export const GetFreightMarkupRateOptions = (
  token: string
): Promise<ApiResponse<FreightMarkupRateOptionsData>> => {
  return new Promise((resolve, reject) => {
    interceptor
      .axiosGet('Get', APIPaths.freightMarkupRatesOptions, token, null)
      .then((res) =>
        resolve(res as unknown as ApiResponse<FreightMarkupRateOptionsData>)
      )
      .catch((error) => reject(error?.response));
  });
};

export const CreateFreightMarkupRate = (
  token: string,
  payload: FreightMarkupRateWritePayload
): Promise<ApiResponse<FreightMarkupRateData>> => {
  return new Promise((resolve, reject) => {
    interceptor
      .axiosPost('Post', APIPaths.freightMarkupRates, payload, token)
      .then((res) =>
        resolve(res as unknown as ApiResponse<FreightMarkupRateData>)
      )
      .catch((error) => reject(error?.response));
  });
};

export const UpdateFreightMarkupRate = (
  token: string,
  rateId: string,
  payload: FreightMarkupRateWritePayload
): Promise<ApiResponse<FreightMarkupRateData>> => {
  return new Promise((resolve, reject) => {
    interceptor
      .axiosPut(
        'Put',
        `${APIPaths.freightMarkupRates}${rateId}/`,
        payload,
        token
      )
      .then((res) =>
        resolve(res as unknown as ApiResponse<FreightMarkupRateData>)
      )
      .catch((error) => reject(error?.response));
  });
};

export const DeleteFreightMarkupRate = (
  token: string,
  rateId: string
): Promise<ApiResponse> => {
  return new Promise((resolve, reject) => {
    interceptor
      .axiosDelete(
        'Delete',
        `${APIPaths.freightMarkupRates}${rateId}/`,
        null,
        token
      )
      .then((res) => resolve(res as unknown as ApiResponse))
      .catch((error) => reject(error?.response));
  });
};
